// i18n area 'hci' — locale hr-HR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.hr-HR.meta.json.
import type { enUS } from './hci'

export const hrHR: typeof enUS = {
  hci: {
    ceph: {
      title: 'Ceph klasteri',
      createButton: 'Stvori Ceph klaster',
      emptyTitle: 'Još nema upravljanog Ceph klastera',
      emptyBody: 'TVirt postavlja i posjeduje Ceph na članskim čvorovima, hiperkonvergentno s VM radnim opterećenjem. Stvorite klaster: prvi monitor i njegov manager nastaju automatski na odabranom upravljačkom čvoru — zatim ga proširite dodatnim monitorima i OSD uređajima.',
      pageTitle: 'Ceph klasteri',
      colState: 'Stanje',
      colMembers: 'Članovi',
      colSize: 'Veličina',
      colVersion: 'Ceph verzija',
      sizeCell: 'iskorišteno {used} GiB od ukupno {total} GiB',
      phase: {
        'not-deployed': 'Nije deployan',
        deploying: 'Deploy u tijeku',
        healthy: 'Ispravan',
        degraded: 'Degradiran',
        error: 'Pogreška',
        destroying: 'Uništavanje u tijeku',
        destroyed: 'Uništen'
      },
      health: {
        HEALTH_OK: 'Ispravno (HEALTH_OK)',
        HEALTH_WARN: 'S upozorenjima (HEALTH_WARN)',
        HEALTH_ERR: 'U pogrešci (HEALTH_ERR)',
        unknown: 'Još nije opažena',
        observedAt: 'opažena {time}'
      },
      create: {
        title: 'Stvorite Ceph klaster',
        info: 'Pri stvaranju novog Ceph klastera bira se prvi čvor na koji će se instalirati uloge MON i MGR. Također treba navesti koju podmrežu koristiti za Ceph promet: public podmreža koristi se za opći mrežni promet, dok se cluster podmreža koristi za interne replike između OSD-ova; različite podmreže nisu strogo nužne.',
        controlNode: 'Upravljački čvor',
        controlNodeHint: 'Članski čvor na kojem nastaju prvi MON + MGR.',
        publicSubnet: 'Public podmreža',
        publicSubnetHint: 'Podmreža registrirana u IPAM-u — Cephova public_network. Nepromjenjiva nakon stvaranja.',
        clusterSubnet: 'Cluster podmreža',
        clusterSubnetHint: 'Podmreža registrirana u IPAM-u — Cephova cluster_network (replikacija/backfill).',
        noSubnets: 'Nijedna podmreža nije registrirana — najprije ih stvorite u IPAM-u',
        sameSubnet: 'Ista podmreža za public i cluster promet',
        sameSubnetHint: 'Označeno = klasterska mreža (replikacija/backfill) podudara se s public mrežom. Neoznačeno = odaberite zasebnu podmrežu I adresu upravljačkog čvora unutar nje.',
        controlAddress: 'Adresa upravljačkog čvora',
        controlAddressHint: 'Adresa koju IPAM poznaje za čvor unutar public podmreže.',
        controlClusterAddress: 'Cluster adresa upravljačkog čvora',
        controlClusterAddressHint: 'Adresa koju IPAM poznaje za čvor unutar cluster podmreže.',
        noAddresses: 'IPAM ne poznaje nijednu adresu ovog čvora unutar odabrane podmreže',
        started: 'Klaster stvoren — bootstrap se nastavlja kao makrozadatak; faza se ažurira sama',
        error: 'Klaster je odbijen'
      },
      detail: {
        actions: 'Dostupne radnje',
        tabOverview: 'Pregled',
        tabManagementNodes: 'MON & MGR',
        tabDisks: 'OSD',
        tabPools: 'Poolovi',
        tabObjects: 'Objekti',
        tabCrush: 'CRUSH karta',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Napredno',
        phase: 'Faza',
        checksTitle: 'Aktivne provjere ispravnosti',
        noChecks: 'Nema aktivnih provjera ispravnosti',
        checkMuted: 'utišano',
        summaryPools: 'Poolovi',
        summaryFilesystems: 'Datotečni sustavi',
        nodesCard: 'Čvorovi',
        monHint: 'MGR radi kolociran uz svaki MON. Tri MON-a preporučeni su kvorum; laboratorijski klaster kreće s jednim. OSD-ovi i MDS-ovi žive u svojim karticama.',
        monHintSplit: 'MON i MGR razdvojeni su na ovom klasteru (Napredno): svaka je uloga vlastiti membership po čvoru. Tri MON-a preporučeni su kvorum; barem jedan MGR mora postojati.',
        noMons: 'Nijedan monitor nije deklariran',
        addNode: 'Dodaj čvor',
        removeNode: 'Ukloni čvor',
        removeNodeFrom: 'Ukloni čvor {node} (njegov MON i kolocirani MGR)',
        roleMon: 'Uloga MON',
        roleMgr: 'Uloga MGR',
        roleNa: 'N/A',
        roleNotObserved: 'još nije opaženo',
        monInQuorum: 'u kvorumu',
        monOutQuorum: 'izvan kvoruma',
        mgrActive: 'aktivan',
        mgrStandby: 'standby',
        addRoleMon: 'Dodaj ulogu MON',
        removeRoleMon: 'Ukloni ulogu MON',
        addRoleMgr: 'Dodaj ulogu MGR',
        removeRoleMgr: 'Ukloni ulogu MGR',
        restartMon: 'Ponovno pokreni MON servis',
        restartMgr: 'Ponovno pokreni MGR servis',
        addMon: 'Dodaj MON',
        removeMon: 'Ukloni MON',
        removeMonFrom: 'Ukloni ulogu MON s {node}',
        addMgr: 'Dodaj MGR',
        removeMgr: 'Ukloni MGR',
        removeMgrFrom: 'Ukloni ulogu MGR s {node}',
        addMds: 'Dodaj MDS',
        removeMds: 'Ukloni MDS',
        removeMdsFrom: 'Ukloni ulogu MDS s {node}',
        mdsSection: 'Poslužitelji metapodataka (MDS)',
        noMds: 'Nijedan MDS nije deklariran — datotečni sustav najprije zahtijeva jedan',
        mdsHint: 'Membership MDS-ova vlastit je od prvog dana: klaster bez CephFS-a ne deklarira nijedan, jedan aktivni plus jedan standby dobro služe datotečni sustav. Ceph bira aktivne i standby među deklariranim daemonima.',
        mdsActiveFor: 'aktivan — {fs}',
        mdsNotObserved: 'još nije opažen',
        lastMdsGuard: 'Posljednji MDS ne može se ukloniti dok postoji datotečni sustav — najprije uklonite datotečne sustave',
        lastMonGuard: 'Posljednji MON ne može se ukloniti — uništavanje klastera jedini je izlaz',
        lastMgrGuard: 'Posljednji MGR ne može se ukloniti — upravljani klaster nikad ne radi bez managera',
        registerDevice: 'Dodaj OSD',
        unregisterDevice: 'Odregistriraj',
        activeDeviceGuard: 'Aktivan OSD — izlazi kroz životni ciklus OSD-a, ne iz registra',
        colNode: 'Čvor',
        devicePhase: { registered: 'Registriran', active: 'Aktivan' },
        health: 'Ispravnost',
        state: 'Stanje',
        fsid: 'fsid',
        fsidPending: 'nedostaje — ponovite bootstrap',
        version: 'Ceph verzija',
        publicNetwork: 'Public mreža',
        clusterNetwork: 'Cluster mreža',
        clusterNetworkCollapsed: '= public',
        noActions: 'U ovoj fazi nije dostupna nijedna radnja',
        destroyedNote: 'Klaster uništen — redak se ubrzo automatski uklanja'
      },
      overview: {
        services: 'Servisi',
        ok: 'ispravno',
        warning: 'warning',
        down: 'ne radi',
        pgTitle: 'Stanja PG-ova',
        pgTotal: 'Ukupno PG-ova: {n}',
        capacityTitle: 'Prostor',
        ioTitle: 'Trenutačni I/O',
        ioReadBw: 'Propusnost čitanja',
        ioWriteBw: 'Propusnost pisanja',
        ioReadIops: 'IOPS čitanja',
        ioWriteIops: 'IOPS pisanja',
        notObserved: 'još nije opaženo'
      },
      osd: {
        colId: 'ID',
        colClass: 'Device class',
        colState: 'Stanje',
        colSize: 'Veličina',
        colPgs: 'PG-ovi',
        empty: 'Još nema OSD-ova — dodajte jedan s deklariranog podatkovnog diska',
        markIn: 'Označi IN',
        markOut: 'Označi OUT',
        scrub: 'Pokreni scrub',
        deepScrub: 'Pokreni deep scrub',
        restart: 'Ponovno pokreni servis',
        details: 'Detalji',
        actionGuard: 'Samo na aktivnom OSD-u deployanog klastera',
        inTitle: 'Označite OSD IN',
        inBody: 'osd.{id} vraća se u raspodjelu podataka (ceph osd in): Ceph radi rebalance podataka natrag na njega.',
        outTitle: 'Označite OSD OUT',
        outBody: 'osd.{id} izlazi iz raspodjele podataka (ceph osd out): njegovi se podaci rebalanceom sele drugamo, a redundancija je SMANJENA dok backfill radi. Reverzibilno u svakom trenutku s Označi IN.',
        scrubTitle: 'Zakažite scrub',
        scrubBody: 'Zakazuje se scrub osd.{id}: mon ga stavlja u red, a stanja PG-ova sljedećih sweepova govore ishod.',
        deepScrubTitle: 'Zakažite deep scrub',
        deepScrubBody: 'Zakazuje se deep scrub osd.{id}: varijanta koja provjerava bajtove — teža za I/O, ista mehanika.',
        restartTitle: 'Ponovno pokrenite OSD servis',
        restartBody: 'osd.{id} zaustavlja se i ponovno pokreće kroz vlastitu superviziju workera na njegovu čvoru.',
        started: 'Radnja pokrenuta — opažanje se ažurira samo',
        error: 'OSD radnja je odbijena'
      },
      osdDetail: {
        title: 'Detalji OSD-a',
        tabGeneral: 'Općenito',
        tabNetwork: 'Mreža',
        tabDevices: 'Uređaji',
        version: 'Verzija',
        hostname: 'Hostname',
        dataPath: 'Putanja podataka OSD-a',
        objectStore: 'Object store OSD-a',
        encrypted: 'Šifriran',
        yes: 'Da',
        no: 'Ne',
        memory: 'Upotreba memorije (PSS)',
        pid: 'Process ID (PID)',
        front: 'Front adresa (client & monitor)',
        hbFront: 'Heartbeat front adresa',
        back: 'Back adresa (OSD)',
        hbBack: 'Heartbeat back adresa',
        colDevice: 'Device',
        colType: 'Tip',
        colPhysical: 'Fizički device',
        colSize: 'Veličina',
        volumeTitle: 'Detalji volumena',
        creationTime: 'Datum stvaranja',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Nijedan device nije opažen za ovaj OSD'
      },
      restart: {
        title: 'Ponovno pokrenite servis',
        monBody: 'MON daemon na {node} zaustavlja se i ponovno pokreće kroz vlastitu superviziju workera.',
        mgrBody: 'MGR daemon na {node} zaustavlja se i ponovno pokreće kroz vlastitu superviziju workera.',
        started: 'Ponovno pokretanje je pokrenuto — opažanje se ažurira samo',
        error: 'Ponovno pokretanje je odbijeno'
      },
      encryptionMode: {
        alwaysOn: 'Uvijek omogućeno (dmcrypt)',
        alwaysOff: 'Uvijek onemogućeno',
        perOsd: 'Izbor po svakom OSD-u',
        section: 'Šifriranje OSD-a at rest',
        title: 'Promijenite način šifriranja OSD-a',
        hint: 'Kako se pripremaju NOVI OSD-ovi. Postojeći OSD-ovi zadržavaju svoje stanje po disku: za promjenu se OSD ukloni i ponovno stvori.',
        body: 'Način postaje "{mode}" i vrijedi SAMO za NOVE OSD-ove: svaki postojeći OSD zadržava svoje trenutačno stanje šifriranja.',
        apply: 'Promijeni način',
        error: 'Promjena načina je odbijena'
      },
      pin: {
        address: 'Public adresa (neobavezni pin)',
        clusterAddress: 'Cluster adresa (neobavezni pin)',
        autoPlaceholder: 'automatski unutar podmreže {cidr}',
        hint: 'Adresiranje po daemonu: prazno = Ceph se sam veže unutar deklarirane mreže; postavljeno = ova se instanca daemona pinom veže na adresu u svojoj conf sekciji.'
      },
      addMon: {
        title: 'Dodajte čvor',
        node: 'Čvor',
        address: 'Public adresa',
        addressHint: 'Adrese čvora koje IPAM poznaje unutar public podmreže — automatski kad postojeća deklaracija pokriva čvor.',
        clusterAddress: 'Cluster adresa',
        clusterAddressHint: 'Obavezno: cluster podmreža je odvojena, a čvor na njoj još nije deklariran.',
        noAddresses: 'IPAM ne poznaje nijednu adresu ovog čvora unutar podmreže',
        error: 'Dodavanje MON-a je odbijeno'
      },
      removeMon: {
        title: 'Uklonite MON',
        body: 'MON i njegov kolocirani MGR napuštaju čvor {node}. Na deployanom klasteru daemoni se zaustavljaju i uklanjaju iz kvoruma.',
        error: 'Uklanjanje MON-a je odbijeno'
      },
      addMgr: {
        title: 'Dodajte MGR',
        node: 'Čvor',
        hint: 'Napredno (razdvojeni MON/MGR): standalone manager nastaje na odabranom članskom čvoru zadatkom vezanim uz čvor. Cephov vlastiti active/standby izbor sam bira aktivni MGR.',
        error: 'Dodavanje MGR-a je odbijeno'
      },
      removeMgr: {
        title: 'Uklonite MGR',
        body: 'Standalone MGR napušta čvor {node}. Na deployanom klasteru daemon se zaustavlja i njegovo se stanje uklanja; MON čvora (ako postoji) ostaje netaknut.',
        error: 'Uklanjanje MGR-a je odbijeno'
      },
      addMds: {
        title: 'Dodajte MDS',
        node: 'Čvor',
        hint: 'Poslužitelj metapodataka CephFS-a: nastaje na odabranom članskom čvoru zadatkom vezanim uz čvor, pod supervizijom workera kao MON i MGR. Ceph sam bira aktivne i standby — jedan aktivni plus jedan standby dobro služe datotečni sustav.',
        error: 'Dodavanje MDS-a je odbijeno'
      },
      removeMds: {
        title: 'Uklonite MDS',
        body: 'MDS napušta čvor {node}. Na deployanom klasteru daemon se zaustavlja i njegovo se stanje uklanja; API odbija posljednji MDS dok ga datotečni sustav treba.',
        error: 'Uklanjanje MDS-a je odbijeno'
      },
      split: {
        title: 'Razdvojeni MON/MGR',
        label: 'Dopusti MON i MGR na disjunktnim čvorovima',
        hint: 'Isključeno (zadano) = ratificirani standard: MGR radi kolociran uz svaki MON, jedan membership. Uključeno = membership MGR-ova postaje vlastit, upravljan radnjama Dodaj/Ukloni MGR u kartici Upravljački čvorovi.',
        enable: 'Omogući',
        disable: 'Onemogući',
        enableBody: 'Membership MGR-ova postaje neovisan o MON-ovima, inicijaliziran iz trenutačne kolokacije. Standalone radnje Dodaj/Ukloni MGR aktiviraju se u kartici Upravljački čvorovi. Ovo opušta zadanu postavku platforme — zadržite samo ako znate zašto vam treba.',
        disableBody: 'Povratak na standardnu kolokaciju: MGR uz svaki MON, jedan membership. Dopušteno samo ako se membership MGR-ova već podudara s MON-ovima — najprije ga poravnajte s Dodaj/Ukloni MGR, ili će API odbiti.',
        error: 'Promjena je odbijena'
      },
      rawEditor: {
        title: 'Sirovi CRUSH editor',
        label: 'Prikaži sirovi editor crushmapa u kartici CRUSH',
        hint: 'Isključeno (zadano) = vođena površina pravila standardni je alat. Uključeno = kartica CRUSH prikazuje i dekompilirani crushmap kao tekst za uređivanje. Spremanje uvijek zahtijeva sudo, naziv klastera kao potvrdu, i prolazi crushtool compile + test PRIJE nego što dosegne klaster.'
      },
      osdFlags: {
        section: 'Globalni OSD flagovi',
        title: 'Override OSD flagova',
        notObserved: 'još nisu opaženi',
        standardFlowsHint: 'Standardni tokovi platforme sami upravljaju ovim flagovima u uobičajenim slučajevima (održavanje čvora postavlja ciljani noout, zamjena diska ide kroz životni ciklus OSD-a). Ova je sekcija ručni override za operatera koji zna što radi.',
        notDeployedGuard: 'OSD flagovi postoje samo na deployanom klasteru',
        set: 'Postavi flag',
        unset: 'Ukloni flag',
        setBody: 'Globalni flag {flag} bit će POSTAVLJEN na osdmapu. Ostaje dok se izričito ne ukloni — zaboravljeni flag degradira samopopravak klastera.',
        unsetBody: 'Globalni flag {flag} bit će UKLONJEN s osdmapa.',
        error: 'Promjena flaga je odbijena',
        flag: {
          noout: 'Nijedan se OSD ne označava out iz raspodjele podataka — nema rebalancea pri gubitku daemona',
          norebalance: 'Rebalance podataka je obustavljen',
          nobackfill: 'Backfill je obustavljen',
          norecover: 'Recovery je obustavljen',
          pause: 'SAV klijentski I/O je pauziran (čitanja i pisanja)',
          noin: 'OSD-ovi pri pokretanju ne označavaju se automatski in',
          nodown: 'Nedostupni OSD-ovi ne označavaju se down — maskira stvarne kvarove'
        }
      },
      pools: {
        section: 'Poolovi',
        create: 'Stvori pool',
        createGuard: 'Poolovi postoje samo na deployanom klasteru',
        notObserved: 'Još nema opažanja poolova — MON sweep izvještava ovdje',
        empty: 'Na klasteru nema nijednog poola',
        colName: 'Naziv',
        colReplication: 'Size / min size',
        colPgNum: 'PG-ovi',
        colApplication: 'Aplikacija',
        colRule: 'CRUSH pravilo',
        colUsage: 'Iskorištenost',
        observedAtLabel: 'Opaženo',
        objects: 'objekata: {n}',
        inUseBy: 'koristi ga {name}',
        internalGuard: 'Interni Ceph pool — platforma ga nikad ne briše',
        delete: 'Izbriši pool',
        deleteGuard: 'Konzumira ga storage {name} — najprije izbrišite storage',
        hint: 'Samo replicirani poolovi (erasure coding izvan scopea v1). Replikacija živi u Cephu: ova je tablica opažena istina iz MON sweepa.',
        createTitle: 'Stvorite pool',
        createHint: 'Pool nastaje na klasteru s traženom replikacijom i omogućenom rbd aplikacijom — posao obavlja zadatak na MON čvoru. Uključite "Predloži kao storage" da ga odmah konzumirate istim potezom.',
        name: 'Naziv poola',
        nameHint: 'DNS-safe (mala slova, znamenke, spojnice).',
        size: 'Replike (size)',
        sizeHint: 'Kopije svakog objekta. Zadano 3.',
        minSize: 'Minimalne replike (min_size)',
        minSizeHint: 'Minimalan broj kopija za posluživanje I/O — prati size − 1 dok ga ne uredite.',
        createError: 'Stvaranje poola je odbijeno',
        deleteTitle: 'Izbrišite pool',
        deleteBody: 'Pool {pool} i SVAKI objekt u njemu nepovratno se uništavaju. Upišite naziv poola za potvrdu.',
        confirmLabel: 'Naziv poola',
        confirmHint: 'Upišite naziv poola za potvrdu',
        deleteError: 'Brisanje poola je odbijeno',
        detailTitle: 'Detalji poola',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Omogućen',
        autoscalerOff: 'Onemogućen',
        autoscalerWarn: 'Obavijesti',
        pgNumLabel: 'Broj PG-ova',
        pgNumCaption: 'Opaženo: autoscaler ga može promijeniti sam — ovo polje upisuje želju.',
        storage: 'Pridruženi TVirt storage',
        addAsStorage: 'Dodaj kao TVirt storage',
        ruleSudoHint: 'Promjena CRUSH pravila zahtijeva lozinku operatera.',
        updateError: 'Izmjena poola je odbijena',
        updated: 'Izmjena poola pokrenuta — opažanje se ažurira samo'
      },
      crush: {
        section: 'CRUSH pravila',
        notObserved: 'Još nema CRUSH opažanja — MON sweep izvještava ovdje',
        empty: 'Nijedno pravilo nije opaženo na klasteru',
        hint: 'Pravilo odlučuje GDJE završavaju kopije svakog objekta — njegova domena kvara jedinica je koja može otkazati bez gubitka podataka. Poolovi pokazuju na pravilo; builtin replicated_rule (jedna replika po poslužitelju) zadano je pravilo od rođenja.',
        create: 'Stvori pravilo',
        createGuard: 'CRUSH pravila postoje samo na deployanom klasteru',
        createTitle: 'Stvorite CRUSH pravilo',
        createHint: 'Jedno pravilo = jedan izbor domene kvara. Pravilo nastaje replicirano na zadanom rootu — posao obavlja zadatak na MON čvoru; poolove pridružite poslije iz kartice Poolovi.',
        createError: 'Stvaranje pravila je odbijeno',
        name: 'Naziv pravila',
        nameHint: 'DNS-safe (mala slova, znamenke, spojnice).',
        domain: 'Domena kvara',
        domainChoice: {
          osd: 'Svaka replika na drugom OSD-u',
          host: 'Svaka replika na drugom poslužitelju',
          rack: 'Svaka replika u drugom racku'
        },
        domainCustom: 'Prilagođeno (ručno napisani stepovi)',
        domainOther: 'Svaka replika u drugom {type}',
        rackGuardHint: 'Nijedan rack bucket ne postoji u opaženoj hijerarhiji: pravilo se svejedno može stvoriti, ali nijedan pool neće moći pokazivati na njega dok rack ne bude deklariran u smještaju članskih poslužitelja (postavke čvora) — zadatak poravnanja gradi bucket i pridruživanje se otvara samo.',
        treeTitle: 'Opažena hijerarhija',
        treeNotObserved: 'Još nema opažanja hijerarhije — MON sweep izvještava ovdje',
        treeOsds: 'OSD-ova: {n}',
        treeHint: 'CRUSH karta kako je vidi klaster: root → deklarirane razine → poslužitelji (hostovi) → OSD-ovi. Topologija prati deklarirani smještaj svakog poslužitelja (postavke čvora) — promjena položaja poravnava je putem zadatka.',
        unplacedWarning: 'Članovi bez deklariranog položaja: {nodes} — njihovi hostovi ostaju izravno pod rootom, izvan deklarirane topologije. Deklarirajte položaj u postavkama čvora (upozorenje, nikad blokada).',
        colName: 'Naziv',
        colDomain: 'Domena kvara',
        colPools: 'Poolovi',
        builtinChip: 'builtin',
        builtinGuard: 'Zadano builtin pravilo klastera — platforma ga nikad ne briše',
        detailAction: 'Detalj pravila',
        detailType: 'Tip',
        backToRules: 'Pravila',
        ruleNotObserved: 'Opaženi popis pravila ne imenuje ovo pravilo',
        noPools: 'Nijedan pool ne koristi ovo pravilo',
        delete: 'Izbriši pravilo',
        deleteTitle: 'Izbrišite CRUSH pravilo',
        deleteBody: 'Pravilo {rule} uklanja se iz crushmapa klastera. Nijedan pool ne smije ga koristiti. Upišite naziv pravila za potvrdu.',
        deleteGuard: 'Koristi ga pool {name} — najprije preusmjerite pool',
        confirmLabel: 'Naziv pravila',
        confirmHint: 'Upišite naziv pravila za potvrdu',
        deleteError: 'Brisanje pravila je odbijeno',
        changeRule: 'Promijeni CRUSH pravilo',
        changeRuleTitle: 'Promijenite CRUSH pravilo',
        changeRuleHint: 'Pool počinje smještati svoje objekte prema odabranom pravilu — Ceph premješta postojeće podatke radi usklađivanja (na punom poolu slijedi rebalance).',
        changeRuleError: 'Promjena pravila je odbijena',
        rule: 'CRUSH pravilo',
        rawTitle: 'Sirovi crushmap (dekompilirani)',
        rawWarning: 'OPASNOST: ovaj je tekst CIJELA politika smještaja klastera. Pogrešna karta može odjednom slomiti placement svih poolova. Spremanje kompilira i testira kartu s crushtoolom PRIJE injektiranja — no valjana karta i dalje može biti loša ideja.',
        rawReload: 'Ponovno učitaj',
        rawLoading: 'Upit u tijeku — read-only zadatak dekompilira crushmap…',
        rawSave: 'Spremi crushmap',
        rawSaveTitle: 'Injektirajte crushmap',
        rawSaveBody: 'Uređeni tekst zamjenjuje crushmap CIJELOG klastera nakon crushtool compile + test. Upišite naziv klastera za potvrdu.',
        rawConfirmLabel: 'Naziv klastera',
        rawConfirmHint: 'Upišite {name} za potvrdu',
        rawError: 'Operacija nad crushmapom nije uspjela',
        rawHint: 'Tekst je oblik crushtool -d. Pogreške kompilacije i testa vraćaju se doslovno iz crushtoola — karta nikad ne dosegne klaster ako ijedan od dva prolaza ne uspije.'
      },
      objects: {
        poolsSection: 'Preglednik objekata',
        poolsHint: 'Odaberite pool za popis njegovih RBD slika. Svako dubinsko čitanje izvodi se kao read-only zadatak na MON čvoru — nikad ne blokira stvarne operacije (niti ga one blokiraju).',
        deployedGuard: 'Upiti nad objektima odgovaraju samo na deployanom klasteru',
        browse: 'Pregledaj objekte',
        detailAction: 'Detalj slike',
        backToPools: 'Poolovi',
        backToImages: 'Slike',
        refresh: 'Osvježi',
        loading: 'Upit u tijeku — read-only zadatak ispituje klaster…',
        error: 'Upit nije uspio',
        retry: 'Pokušaj ponovno',
        notRbd: 'Pool s application "{app}" — ne sadrži RBD slike, ovdje nema što istraživati',
        noImages: 'U ovom poolu nema RBD slika',
        colImage: 'Slika',
        colSize: 'Veličina',
        colObjects: 'Objekti',
        colSnapshots: 'Snimke',
        imagesHint: 'Diskovi na konzumirajućem rbd storageu jesu slike nazvane po ID-u svog diska. Broj objekata je provisioned (veličina / veličina objekta) — stvarna upotreba živi u detalju slike.',
        infoTitle: 'Slika',
        infoSize: 'Virtualna veličina',
        infoObjects: 'Objekti (provisioned)',
        infoObjectSize: 'Veličina objekta',
        infoPrefix: 'Prefiks objekata',
        infoFormat: 'Format',
        infoFeatures: 'Feature',
        usageTitle: 'Stvarna upotreba (rbd du)',
        usageOf: 'od {provisioned} GiB provisioned',
        usageHint: 'Thin po prirodi: samo zapisani objekti zauzimaju bajtove.',
        watchersTitle: 'Watcheri',
        noWatchers: 'Nema watchera — nitko trenutačno nema otvorenu ovu sliku',
        snapshotsTitle: 'RBD snimke',
        noSnapshots: 'Na ovoj slici nema nijedne RBD snimke',
        colSnapshot: 'Snimka',
        colProtected: 'Zaštićena',
        colTimestamp: 'Stvorena',
        protected: 'zaštićena',
        mappingTitle: 'Fizičko mapiranje (skup OSD-ova)',
        mappingSampled: 'Uzorkovano objekata: {sampled} od ukupno {total} — pošten sažetak: za velike slike skup konvergira prema SVIM OSD-ovima poola (CRUSH raspodjeljuje objekte po cijelom poolu).',
        mappingComplete: 'Svi objekti mapirani ({total} od {total}).',
        objectQueryTitle: 'Mapirajte pojedinačni objekt',
        objectName: 'Naziv objekta',
        objectHint: 'Nazivi RADOS objekata jesu <prefiks>.<16-hex indeks> — ceph osd map odgovara s PG-om i OSD trojkama.',
        mapObject: 'Mapiraj',
        primary: 'primarni: osd.{osd}'
      },
      registerDevice: {
        title: 'Registrirajte OSD uređaj',
        hint: 'Na živom klasteru registracija i PRIPREMA uređaj: postaje BlueStore OSD automatskim zadatkom vezanim uz čvor (nikad prazno, ratificirano 2026-07-24). Uređaj pripada najviše jednom Ceph klasteru u cijeloj floti.',
        disk: 'Podatkovni disk',
        diskHint: 'Deklarirani podatkovni diskovi čvora — naziv i serijski broj',
        noDeclared: 'Na ovom čvoru nije deklariran nijedan podatkovni disk — najprije ih označite u lokalnim postavkama čvora',
        serialHint: 'Serijski broj uređaja — pin identiteta',
        encrypted: 'Šifriraj ovaj OSD (dmcrypt)',
        encryptedHint: 'Izbor po OSD-u (način klastera je "izbor po svakom OSD-u"): zamrzava se na ovom disku pri registraciji — kasnija promjena načina nikad ga ne prepisuje; to čini radnja retka šifriraj/dešifriraj.',
        error: 'Registracija je odbijena'
      },
      unregisterDevice: {
        title: 'Odregistrirajte uređaj',
        body: 'Samo registar: {name} prestaje biti OSD kandidat ovog klastera. Njegovi bajtovi se ne diraju.',
        error: 'Odregistracija je odbijena'
      },
      deploy: {
        action: 'Ponovi deploy',
        title: 'Ponovite bootstrap',
        body: 'Bootstrap rođenja ponovno kreće iz trenutačne konfiguracije: MON-ovi se pokreću, svaki registrirani uređaj priprema se i aktivira kao BlueStore OSD. Operacija se izvodi kao makrozadatak — faza se ažurira sama.',
        started: 'Bootstrap pokrenut — nastavlja se kao makrozadatak; faza se ažurira sama',
        error: 'Bootstrap je odbijen'
      },
      propose: {
        action: 'Predloži kao storage',
        title: 'Predložite kao storage',
        hintPool: 'Postojeći pool {name} postaje TVirt storage: cephx identitet ograničen na pool završava u keystoreu i ceph-rbd storage nastaje spreman. Prijedlog konzumira pool — nikad ga ne stvara.',
        hintFs: 'Postojeći datotečni sustav {name} postaje TVirt storage: cephx identitet ograničen na datotečni sustav završava u keystoreu i cephfs storage nastaje spreman i montiran. Prijedlog konzumira datotečni sustav — nikad ga ne stvara.',
        name: 'Naziv storagea',
        nameHint: 'DNS-1123, jedinstven u scopeu — cephx identitet dobiva ime po njemu.',
        path: 'Path unutar datotečnog sustava',
        pathHint: 'Apsolutni path unutar datotečnog sustava koji storage montira — / ako ste u dvojbi.',
        alsoPropose: 'Predloži odmah kao storage',
        alsoProposePoolHint: 'Nakon stvaranja isti potez predlaže novorođeni pool kao ceph-rbd storage — dva eksplicitna poziva, jedan dijalog.',
        alsoProposeFsHint: 'Nakon stvaranja isti potez predlaže novorođeni datotečni sustav kao cephfs storage — dva eksplicitna poziva, jedan dijalog.',
        guard: 'Predloži kao storage — samo na healthy klasteru',
        started: 'Prijedlog prihvaćen — storage se materijalizira; naći ćete ga pod Storage',
        submit: 'Stvori storage',
        error: 'Prijedlog je odbijen'
      },
      fs: {
        section: 'Datotečni sustavi',
        create: 'Stvori datotečni sustav',
        createGuard: 'Datotečni sustavi postoje samo na deployanom klasteru',
        mdsFirstGuard: 'Najprije dodajte MDS — datotečni sustav bez poslužitelja metapodataka nastaje neupotrebljiv',
        notObserved: 'Još nema opažanja datotečnih sustava — MON sweep izvještava ovdje',
        empty: 'Na klasteru nema nijednog datotečnog sustava',
        colName: 'Naziv',
        colPools: 'Poolovi',
        colMds: 'MDS',
        noActiveMds: 'nema aktivnog MDS-a',
        delete: 'Ukloni datotečni sustav',
        deleteGuard: 'Konzumira ga storage {name} — najprije izbrišite storage',
        hint: 'Datotečni sustav posjeduje svoje poolove za podatke i metapodatke (cephfs.<naziv>.data / .meta): nastaju s njim i umiru s njim — removeFs, nikad ručno brisanje poola. Ova je tablica opažena istina iz MON sweepa.',
        createTitle: 'Stvorite datotečni sustav',
        createHint: 'Datotečni sustav nastaje na klasteru sa svoja dva poola (application cephfs) i poslužuju ga deklarirani MDS-ovi — posao obavlja zadatak na MON čvoru. Uključite "Predloži kao storage" da ga odmah konzumirate istim potezom.',
        name: 'Naziv datotečnog sustava',
        nameHint: 'DNS-safe (mala slova, znamenke, spojnice).',
        sizeHint: 'Replike OBA novorođena poola. Zadano 3.',
        createError: 'Stvaranje datotečnog sustava je odbijeno',
        deleteTitle: 'Uklonite datotečni sustav',
        deleteBody: 'Datotečni sustav {fs} i SVAKA datoteka u njemu nepovratno se uništavaju — njegovi poolovi za podatke i metapodatke umiru s njim. Upišite naziv datotečnog sustava za potvrdu.',
        confirmLabel: 'Naziv datotečnog sustava',
        confirmHint: 'Upišite naziv datotečnog sustava za potvrdu',
        deleteError: 'Uklanjanje datotečnog sustava je odbijeno'
      },
      destroy: {
        action: 'Uništi',
        retryAction: 'Ponovi uništavanje',
        retryGuard: 'Uništavanje je u tijeku — ponovni pokušaj vrijedi za neuspjelo uništavanje (lease inače odbija)',
        title: 'Uništite klaster',
        body: 'Deployani fabric se demontira: svaki daemon ovog klastera se zaustavlja, njegovo se stanje u sustavu i ključevi u keystoreu oslobađaju. Kad uništavanje uspije, klaster se automatski uklanja.',
        confirmLabel: 'Naziv klastera',
        confirmHint: 'Upišite naziv klastera za potvrdu',
        wipe: 'Obriši registrirane uređaje',
        wipeHint: 'Označeno: potpisi svakog registriranog uređaja se brišu — podaci na njima su uništeni. Neoznačeno: bajtovi ostaju netaknuti i uređaji se vraćaju u stanje registriranih.',
        guard: 'Uništi — ništa nije deployano',
        started: 'Uništavanje pokrenuto — nastavlja se kao makrozadatak; faza se ažurira sama',
        error: 'Uništavanje je odbijeno'
      },
      delete: {
        guard: 'Izbriši — samo konfiguracija koja nije deployana (najprije uništite)',
        title: 'Izbrisati {name}?',
        body: 'Konfiguracija i njezin registar uređaja se uklanjaju. Dopušteno samo dok ništa nije deployano.',
        error: 'Brisanje je odbijeno'
      }
    }
  }
}
